import React from 'react';

export default function Terms() {
  return (
    <div className="mx-auto max-w-3xl px-6 lg:px-10 py-14" data-testid="page-terms">
      <div className="font-mono text-xs uppercase tracking-widest text-[#ff2a2a] mb-2">Terms & Privacy</div>
      <h1 className="font-display text-4xl sm:text-5xl uppercase tracking-tight leading-none">Terms of Service</h1>
      <p className="mt-3 text-zinc-500 text-sm">Last updated: February 2026</p>

      <div className="mt-10 space-y-8 text-zinc-300 text-sm leading-relaxed">
        <section>
          <h2 className="font-display text-2xl uppercase tracking-tight text-white mb-3">1. Acceptance</h2>
          <p>By downloading, installing, or using AutoMobile, you agree to these Terms and our Privacy Policy. If you do not agree, do not use the service.</p>
        </section>
        <section>
          <h2 className="font-display text-2xl uppercase tracking-tight text-white mb-3">2. PIPEDA Compliance</h2>
          <p>AutoMobile complies with Canada&rsquo;s Personal Information Protection and Electronic Documents Act (PIPEDA). We collect only what we need, store it securely, and never sell your data to third parties.</p>
        </section>
        <section>
          <h2 className="font-display text-2xl uppercase tracking-tight text-white mb-3">3. Marketplace & Commissions</h2>
          <p>Listing is free. AutoMobile charges a commission on completed sales (1.5%–5% based on your tier). Payment processors&rsquo; standard fees may apply.</p>
        </section>
        <section>
          <h2 className="font-display text-2xl uppercase tracking-tight text-white mb-3">4. Ride Sharing</h2>
          <p>AutoMobile is a peer-to-peer coordination platform. Drivers and passengers are responsible for their own conduct, insurance, and compliance with local regulations.</p>
        </section>
        <section>
          <h2 className="font-display text-2xl uppercase tracking-tight text-white mb-3">5. Content & Conduct</h2>
          <p>You retain ownership of content you post. You grant AutoMobile a limited license to display it. Harassment, fraud, and illegal activity result in removal and possible legal referral.</p>
        </section>
        <section>
          <h2 className="font-display text-2xl uppercase tracking-tight text-white mb-3">6. Contact</h2>
          <p>Questions? Reach us at <a href="mailto:hello@automobile.direct" className="text-[#ff2a2a] hover:underline">hello@automobile.direct</a>.</p>
        </section>
      </div>
    </div>
  );
}
